import { Component, inject, input } from '@angular/core';
import { JwtAuthService } from '../../services/jwt-auth';
import { FileManagerListComponent } from './file-manager-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ava-file-manager',
  standalone: true,
  template: `
    @if ((jwtAuthService.afAuthIdTokenResult$ | async) && directory()) {
      <ava-file-manager-list [directory]="directory()" />
    }
  `,
  imports: [FileManagerListComponent, AsyncPipe],
})
export class FileManagerComponent {
  readonly jwtAuthService = inject(JwtAuthService);

  directory = input('');
}
